import { Reducer } from 'redux';
import { getType } from '@anm/helpers/saga/typesafe-actions';

import { replaceVideoAsync } from '../actions';
import { HostedVideoActions } from '../types';

import { initialHostedVideoState } from './index';

const replaceVideoReducer: Reducer<typeof initialHostedVideoState, HostedVideoActions> = (
  state = initialHostedVideoState,
  action
) => {
  switch (action.type) {
    case getType(replaceVideoAsync.request): {
      return {
        ...state,
        replaceVideo: {
          ...state.replaceVideo,
          isPending: true
        }
      };
    }
    case getType(replaceVideoAsync.success): {
      return {
        ...state,
        replaceVideo: {
          ...state.replaceVideo,
          isPending: false
        }
      };
    }
    case getType(replaceVideoAsync.failure): {
      return {
        ...state,
        replaceVideo: {
          isPending: false,
          isError: true,
          error: action.payload
        }
      };
    }
    default:
      return state;
  }
};

export default replaceVideoReducer;
